import React from "react";
import {FormattedMessage} from "react-intl";

import SvgIcon from "@mui/material/SvgIcon";

import {GroheArchitectureIcon} from "../../../common/icons";
import LeadCapturePopupBoxImage from "./leadCapturePopupBoxImage";
import {capitalizeFirstLetters} from "../../../../misc/helpers";
import {getCommonVisualizerType} from "../../../../config";


const LeadCapturePopupBox = (props) => {

  const {fabricatorData} = props;

  return (
    <div className="grohe-lead__right">
      <div className="grohe-lead__canvas">
        <LeadCapturePopupBoxImage className="grohe-lead__canvas-image animate__background-slide"/>
      </div>
      <div className={"grohe-lead__box" + (fabricatorData.isEncore || fabricatorData.isNhance ? " grohe-lead__box--small" : "")}>
        <div className="grohe-lead__box-icon">
          <SvgIcon style={{ fontSize: "inherit" }}>
            <GroheArchitectureIcon/>
          </SvgIcon>
        </div>
        <p className="grohe-lead__box-title">
          <FormattedMessage id="leadCapturePopup.design.title" values={{
            visualizerType: capitalizeFirstLetters(getCommonVisualizerType())
          }}/>
        </p>
        {fabricatorData.isEncore || fabricatorData.isNhance ? null : (
          <p className="grohe-lead__box-sub-title">
            <FormattedMessage id="leadCapturePopup.design.subTitle"/>
          </p>
        )}
      </div>
    </div>
  )
};

export default LeadCapturePopupBox
